import { mooberApiV2 as apiV2 } from '@/api/mooberApi';

const initiate = ({ companyId }) => apiV2.get(`/company/${companyId}/xero/direct`);
const saveAuthentication = ({ code, companyId, state }) => apiV2.post(`/company/${companyId}/xero/direct`, { code, state });
const revokeAuthentication = ({ companyId }) => apiV2.delete(`/company/${companyId}/xero/direct`);
const getContacts = companyId => apiV2.get(`/company/${companyId}/xero/contacts`);
const getAccounts = companyId => apiV2.get(`/company/${companyId}/xero/accounts`);
const getSalesItems = companyId => apiV2.get(`/company/${companyId}/xero/salesItems`);
const createConsolidatedInvoice = ({ companyId, body }) => apiV2.post(`/company/${companyId}/xero/contracts/vendorInvoice`, body);
/* ========== */

export default {
  initiate,
  saveAuthentication,
  revokeAuthentication,
  getContacts,
  getAccounts,
  getSalesItems,
  createConsolidatedInvoice,
  /* ========== */
};



// WEBPACK FOOTER //
// ./src/api/xero.js